// WikiSpeedrunModals.js
import React from "react";
import WikiModal from "./WikiModal";

export const initialModal = (startPage, targetPage) => ({
  title: "Welcome to Wiki Speedrun!",
  description: (
    <div className="modal-description-body">
      <div className="modal-description-title">
        Ready to test your Wikipedia agility?
      </div>
      <div className="modal-description-contents">
        <p>
          You’ll begin at a random Wikipedia page and must navigate to the
          target page using only in-page links.
        </p>
        <p>
          The timer starts when you click <strong>Start</strong> and keeps
          running until you hit <strong>Stop</strong> — so don’t forget to stop
          it when you arrive!
        </p>
        <br />
        <p>
          Your target page is: <strong>{targetPage}</strong>
        </p>
      </div>
      <div className="modal-description-wikipedia">
        <WikiModal page={targetPage} />
      </div>
      <div className="modal-description-footer">
        Time is ticking — can you beat the clock?
      </div>
    </div>
  ),
  buttonText: "Start",
  buttonType: "start",
});